import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'betrag'
})
export class BetragPipe implements PipeTransform {
  constructor(private number: DecimalPipe) {}

  transform(value: number, currencyCode = false): string {
    if (!value && value !== 0) {
      return '';
    } else if (isNaN(value)) {
      return value.toString();
    }
    const currency = currencyCode ? ' CHF' : '';
    return this.number.transform(value, '1.2', 'de-CH') + currency;
  }
}
